module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGcbf84e461ddf92f733231bd1fd49de3f.cbf84e46.png";